// ============================================================
//  src/admin/components/DataTable.js
//  One column config -> a real <table> on desktop and a
//  stacked card list on mobile. Avoids duplicating markup
//  across every list page.
//
//  columns: [{
//    key:        unique key
//    label:      header label / card field label
//    render:     (row) => ReactNode   (defaults to row[key])
//    align:      'left' | 'right'
//    primary:    true for the one column shown as the card title
//    hideOnCard: true to omit from the mobile card body
//  }]
// ============================================================
import React from 'react';

export default function DataTable({
  columns,
  rows,
  keyField,
  onRowClick,
  loading,
  loadingMessage = 'Loading…',
  emptyMessage = 'Nothing here yet.',
}) {
  if (loading) {
    return <div className="bf-empty"><span className="spinner spinner-dark" /> {loadingMessage}</div>;
  }
  if (!rows || rows.length === 0) {
    return <div className="bf-empty">{emptyMessage}</div>;
  }

  const primaryCol = columns.find(c => c.primary);
  const cardCols = columns.filter(c => !c.primary && !c.hideOnCard);

  return (
    <>
      <div className="bf-table-wrap">
        <table className="bf-table">
          <thead>
            <tr>
              {columns.map(c => (
                <th key={c.key} style={c.align === 'right' ? { textAlign: 'right' } : undefined}>{c.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map(row => (
              <tr
                key={row[keyField]}
                className={onRowClick ? 'bf-row-clickable' : undefined}
                onClick={onRowClick ? () => onRowClick(row) : undefined}
              >
                {columns.map(c => (
                  <td key={c.key} style={c.align === 'right' ? { textAlign: 'right' } : undefined}>
                    {c.render ? c.render(row) : row[c.key]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="bf-card-list">
        {rows.map(row => (
          <div
            key={row[keyField]}
            className={onRowClick ? 'bf-row-card bf-row-clickable' : 'bf-row-card'}
            onClick={onRowClick ? () => onRowClick(row) : undefined}
          >
            {primaryCol && (
              <div className="bf-row-card-title">
                {primaryCol.render ? primaryCol.render(row) : row[primaryCol.key]}
              </div>
            )}
            <div className="bf-row-card-grid">
              {cardCols.map(c => (
                <div key={c.key} className="bf-row-card-line">
                  <span className="bf-row-card-label">{c.label}</span>
                  <span className="bf-row-card-value">{c.render ? c.render(row) : row[c.key]}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}